import CloseButton from "src/components/button/close-button";
import Text from "src/components/text/text";
import TextToSpeech from "src/components/text/text-speech";
import { useEffect, useState, useRef } from "react";
import { useNavigationStore } from "src/store/navigationStore";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { CHAT_TYPE } from "@/types/navigation-mode";
import { ShareButton } from "@/components/button/share-button";
import ChatText from "@/components/text/chat-text";
import HtmlText from "@/components/text/html-text";
import useMdBreakpoint from "@/hooks/useMdBreakpoint";
import { useAppStore } from "@/store/appStore";
import SimTimer from "./sim-timer";
import { useCrimeSceneStore } from "@/store/crimeSceneStore";
import { useAudioStore } from "@/store/audioStore";
import { useLanguageStore } from "@/store/languageStore";

export default function SimHeader() {
  const currentLevel = useCrimeSceneStore((state) => state.currentLevel);

  const stopAutoPlay = useCrimeSceneStore((state) => state.stopAutoPlay);

  const [showNavMessage, setShowNavMessage] = useState(false);

  const sceneMessages = useCrimeSceneStore((state) => state.sceneMessages);

  const micInstruction = useAppStore((state) => state.micInstruction);
  const showNavError = useAppStore((state) => state.showNavError);
  const isVoiceChatMode = useAppStore((state) => state.isVoiceChatMode);
  // const setConversationId = useNavigationStore(
  //   (state) => state.setConversationId
  // );
  const resetNavigationSessionData = useNavigationStore(
    (state) => state.resetNavigationSessionData
  );
  const setCurrentMode = useNavigationStore((state) => state.setCurrentMode);
  const navMode = useNavigationStore((state) => state.navMode);
  const setInterrupt = useNavigationStore((state) => state.setInterrupt);
  const isChatOpen = useAppStore((state) => state.isChatOpen);
  const setChatType = useAppStore((state) => state.setChatType);
  const chatOpenRef = useRef(isChatOpen);
  const startPlayMessagesData = useCrimeSceneStore(
    (state) => state.startPlayMessagesData
  );
  const resetStartPlayMessagesData = useCrimeSceneStore(
    (state) => state.resetStartPlayMessagesData
  );

  const voiceLang = useLanguageStore((s) => s.voiceLanguage);

  const latestSceneMessages = useRef<string[]>([]);
  const processingSceneMessageIndex = useRef<number>(0);
  const [processingSceneMessage, setProcessingSceneMessage] =
    useState<string>("");
  const sceneIndex = useCrimeSceneStore((state) => state.sceneIndex);

  const setHasFinishSceneMessage = useCrimeSceneStore(
    (state) => state.setHasFinishSceneMessage
  );

  const resetSimulationData = useCrimeSceneStore(
    (state) => state.resetSimulationData
  );
  const setStop = useAudioStore((s) => s.setStop);
  const audioVoice = useAudioStore((s) => s.audioVoice);
  const setPause = useAudioStore((s) => s.setPause);
  const setResume = useAudioStore((s) => s.setResume);
  const showSceneDialog = useCrimeSceneStore((s) => s.showSceneDialog);
  const isMd = useMdBreakpoint();
  let navigate = useNavigate();
  let { t } = useTranslation();
  // useEffect(() => {
  //   console.log("navigationMessage=", navigationMessage);
  //   latestMessage.current = navigationMessage;
  //   if (navigationMessage !== "") {
  //     stopAutoPlay();
  //     setShowNavMessage(true);
  //   } else if (navigationMessage === "") {
  //     setShowNavMessage(false);
  //   }
  // }, [navigationMessage]);

  useEffect(() => {
    console.log("sceneMessages", sceneMessages);
    latestSceneMessages.current = sceneMessages;
    processingSceneMessageIndex.current = 0;
    setProcessingSceneMessage("");
  }, [sceneMessages]);

  function nextMessage() {
    if (
      processingSceneMessageIndex.current <
      latestSceneMessages.current.length - 1
    ) {
      console.log("next message !!!!");

      setTimeout(() => {
        processingSceneMessageIndex.current += 1;
        setProcessingSceneMessage(
          latestSceneMessages.current[processingSceneMessageIndex.current] ?? ""
        );
      }, 100);

      // processingSceneMessageIndex.current += 1;
      // processingSceneMessage.current = latestSceneMessages.current[processingSceneMessageIndex.current] ?? "";
      // console.log(processingSceneMessage.current);
    } else {
      setHasFinishSceneMessage(true);
      setProcessingSceneMessage("");
    }
  }

  useEffect(() => {
    console.log("startPlayMessagesData", startPlayMessagesData);
    if (startPlayMessagesData === -1) return;
    resetStartPlayMessagesData();
    setProcessingSceneMessage("");
    setHasFinishSceneMessage(false);
    setTimeout(() => {
      processingSceneMessageIndex.current = 0;
      setProcessingSceneMessage(
        latestSceneMessages.current[processingSceneMessageIndex.current] ?? ""
      );
    }, 100);
  }, [startPlayMessagesData]);

  useEffect(() => {
    startAutoPlay();
  }, []);

  useEffect(() => {
    chatOpenRef.current = isChatOpen;
    console.log("simulation isChatOpen");
    if (isChatOpen) {
      setPause();
    } else {
      setResume();
    }
  }, [isChatOpen]);

  // const hideMessage = () => {
  //   if (!chatOpenRef.current) {
  //     startAutoPlayDelay(0);
  //   }
  // };

  const startAutoPlay = () => {
    // setShowAnswer(false);
    setShowNavMessage(true);
    if (!chatOpenRef.current) {
      //don't use delay(2000) here
      // setTimeout(() => {
      //   startAutoPlayDelay(0);
      // }, 2000);
    }
  };

  const showMobileChatbotQuestion = () => {
    return (
      <div className="p-[20px] md:block">
        <ChatText
          fromChatBot={true}
          text={t("chatbot_default")}
          useTypeWriter={true}
        />
      </div>
    );
  };

  const showNavigationAnswer = () => {
    const url = `${audioVoice}/${voiceLang}/scene${sceneIndex}_${processingSceneMessageIndex.current}.mp3`;

    return (
      <>
        <div className="p-[20px] md:block">
          <TextToSpeech
            text={t(processingSceneMessage)}
            onFinish={() => nextMessage()}
            audioFile={url}
            showText={
              !isChatOpen &&
              !showSceneDialog &&
              showNavMessage &&
              processingSceneMessage !== ""
            }
          />
        </div>
      </>
    );
  };

  const showMessages = () => {
    return (
      <>
        {isChatOpen && !isMd && showMobileChatbotQuestion()}
        {showNavigationAnswer()}
      </>
    );
  };

  const showMicPermission = () => {
    const text = `${t("chat_grant_mic_permission")}\n${t(micInstruction)}`;
    return (
      <div className="p-[20px] md:block">
        <HtmlText text={text} tag="b" />
        <TextToSpeech text={text} showText={false} />
      </div>
    );
  };

  const resetChat = () => {
    console.log("reset chat");
    setStop();
    // setConversationId(""); // reset chatbot conversation
    setCurrentMode(navMode); // reset navigation mode to preferred mode in settings
    stopAutoPlay();
    setInterrupt(true);
    setChatType(CHAT_TYPE.NAVIGATION);
    resetNavigationSessionData();
    resetSimulationData();
    navigate("/");
  };

  return (
    <>
      <div className="flex justify-end items-center px-[20px] pt-[20px]">
        <div className="flex flex-1">
          <Text
            text={currentLevel}
            className="bg-glass floor-indicator flex items-center justify-center text-500"
          />
        </div>

        <div
          className="flex flex-1 justify-center"
        >
          <SimTimer />
        </div>
        <div className="flex flex-1 justify-end z-50 gap-4">
          <div>
            <ShareButton />
          </div>
          <CloseButton
            goBack={false}
            onClick={() => resetChat()}
            withGlassBg={true}
          />
        </div>
      </div>
      {showNavError && isVoiceChatMode ? showMicPermission() : showMessages()}
    </>
  );
}
